export default __webpack_public_path__ + "static/media/agustin15.7088fe5f.png";